import request from "./request";

export const getInfo = () => request.get('posts/1')

export const GetPosts = () => request.get('posts/1')

export const GetsearchData = (params) => request.get('/list',{params})

export const PostPosts = (params) => request.post('posts',params)


// 以get方式进行请求
export function axiosGet(url,parameter={}) {

    return request({
        url: url,
        method: 'get',
        params: parameter
    })

}

// 以post方式进行请求
export function axiosPost(url,parameter={}) {

    return request({
        url: url,
        method:'post' ,
        data: parameter

    })

}
